import React from 'react';
import { getOrderByValue, searchWithFilter, getAvailableJobsAvailable } from './jobs-filter/CareersPageFilterService';
import { CS_Radio, CS_Space, CS_Text, CS_Dropdown, CS_Row } from '../visual_components';

export default function SortByComponent() {
	const total_jobs_count = getAvailableJobsAvailable();
	const order_by_value = getOrderByValue();
	const sort_by_options = [{ name: 'Most recent', key: 'most_recent' }, { name: 'Name', key: 'title' }];
	const slected_sort_by_value = order_by_value === 'most_recent' ? 'Most recent' : 'Name';
	return (
		<CS_Row vcenter={true} right_aligned={true} className="hidden-xs">
			<CS_Text size={4} boldness="bold">
				{total_jobs_count} {total_jobs_count === 1 ? 'Job' : 'Jobs'}
				<CS_Space size={2} />|
			</CS_Text>
			<CS_Space size={2} />
			<CS_Text>Sort By</CS_Text>
			<CS_Space size={2} />
			<CS_Dropdown id="sortByDropdown" value={slected_sort_by_value}>
				{sort_by_options.map(option => (
					<CS_Radio
						key={option.key}
						name={'sort_by'}
						value={option.key}
						defaultChecked={order_by_value === option.key}
						onChange={searchWithFilter}>
						{option.name}
					</CS_Radio>
				))}
			</CS_Dropdown>
		</CS_Row>
	);
}
